import Container from "react-bootstrap/Container";

function Component() {
  return (
    <div className="d-flex align-items-center justify-content-center p-4">
      Please refresh the page.
    </div>
  );
}

export default Component;
